import { Component, inject } from '@angular/core';
import { DialogRef, DialogContentBase } from '@progress/kendo-angular-dialog';
import { catchError, Observable, take, takeUntil, Subject, tap, switchMap, pipe, forkJoin } from 'rxjs';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import * as svgIcons from '@progress/kendo-svg-icons';
import { DynamicEntityService } from 'src/app/module/servicentre/dynamic-entity.service';
import { TicketTypeService } from '../../../ticket-type/ticket-type.service';
import { ServiceSharedService } from '../../../shared/service-shared-services';
import { LocalStorage } from 'src/app/core/local-storage.enum';
import { UserService } from 'src/app/module/security/user/user.service';

@Component({
  selector: 'app-ticket-header-user-preset-popup',
  templateUrl: './ticket-header-user-preset-popup.component.html',
  styleUrls: ['./ticket-header-user-preset-popup.component.scss'],
})
export class TicketHeaderUserPresetPopupComponent extends DialogContentBase {
  private dynamicEntityService = inject(DynamicEntityService);
  private ticketTypeService = inject(TicketTypeService);
  private serviceSharedService = inject(ServiceSharedService);
  private userService = inject(UserService);

  public allIcons = svgIcons;

  public scInvoicingCategoryCode = '';
  public scTicketType = '';
  public scLocalisation = '';

  public invoicingCategoryList: string[] = [];
  public ticketTypeList: string[] = [];
  public localisationList: string[] = [];

  public invoiceCategoryFilterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: 'contains',
  };

  public ticketTypeFilterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: 'contains',
  };

  public localisationFilterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: 'contains',
  };

  constructor(public override dialog: DialogRef) {
    super(dialog);

    // fetch data
    forkJoin({
      invoicingCategoryList: this.dynamicEntityService.getListOfInvoicingCategory(false),
      ticketTypeList: this.ticketTypeService.listCache(),
      localisationList: this.serviceSharedService.getListOfLocalisation(),
    }).subscribe((response: any) => {
      this.localisationList = response.localisationList;
      this.invoicingCategoryList = response.invoicingCategoryList;
      this.ticketTypeList = response.ticketTypeList;
    });

    // set current values
    this.scInvoicingCategoryCode = this.userService.getUserPreference('ticket_header_scInvoicingCategoryCode');
    this.scTicketType = this.userService.getUserPreference('ticket_header_scTicketType');
    this.scLocalisation = this.userService.getUserPreference('ticket_header_scLocalisation');
  }

  close() {
    this.dialog.close();
  }

  savePreset() {
    this.userService.saveUserPreference('ticket_header_scInvoicingCategoryCode', this.scInvoicingCategoryCode);
    this.userService.saveUserPreference('ticket_header_scTicketType', this.scTicketType);
    this.userService.saveUserPreference('ticket_header_scLocalisation', this.scLocalisation);
    this.close();
  }
}
